import GeneratedRegistrationServiceApi from "./generated/GeneratedRegistrationServiceApi"

class RegistrationServiceApi extends GeneratedRegistrationServiceApi {

}

export const registrationServiceApi = new RegistrationServiceApi()
